import React from "react";
// Иконки из макета, перекрашенные в currentColor — цвет задаётся через CSS `color`
import {ReactComponent as Cfp} from '../../../theme/assets/redesign/icons/cfp.svg';
import {ReactComponent as Wallet} from '../../../theme/assets/redesign/icons/wallet.svg';
import {ReactComponent as Roadmap} from '../../../theme/assets/redesign/icons/roadmap.svg';
import {ReactComponent as Leaderboard} from '../../../theme/assets/redesign/icons/leaderboard.svg';
import {ReactComponent as Users} from '../../../theme/assets/redesign/icons/users.svg';
import {ReactComponent as Gift} from '../../../theme/assets/redesign/icons/gift.svg';
import {ReactComponent as Settings} from '../../../theme/assets/redesign/icons/settings.svg';
import {ReactComponent as Document} from '../../../theme/assets/redesign/icons/document.svg';
import {ReactComponent as Coins} from '../../../theme/assets/redesign/icons/coins.svg';
import {ReactComponent as More} from '../../../theme/assets/redesign/icons/more.svg';
import {ReactComponent as Logout} from '../../../theme/assets/redesign/icons/logout.svg';
import {ReactComponent as Calendar} from '../../../theme/assets/redesign/icons/calendar.svg';
import {ReactComponent as CalendarPlain} from '../../../theme/assets/redesign/icons/calendar_plain.svg';
import {ReactComponent as List} from '../../../theme/assets/redesign/icons/list.svg';

const ICONS = {
    cfp: Cfp,
    wallet: Wallet,
    roadmap: Roadmap,
    leaderboard: Leaderboard,
    users: Users,
    gift: Gift,
    settings: Settings,
    document: Document,
    coins: Coins,
    more: More,
    logout: Logout,
    calendar: Calendar,
    list: List,
    calendarPlain: CalendarPlain,
};

const DsIcon = ({name, size = 24, className}) => {
    const Icon = ICONS[name];
    if (!Icon) return null;
    return <Icon width={size} height={size} className={className} style={{flexShrink: 0, display: 'block'}} aria-hidden="true"/>;
};

export default DsIcon;
